import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseActionsSearch } from "@/features/administration";
import { ActionsPage } from "@/features/administration/pages";
import { ProblemError } from "@/shared/api/problem";
import { strictSearch } from "@/shared/lib/search";

/** What staff did holds names and the values a change replaced: hg-audit gives it to a superadmin alone. */
export const Route = createFileRoute("/_app/settings/actions")({
  beforeLoad: ({ context }) => {
    if (context.role !== "superadmin") {
      throw new ProblemError({ status: 403, code: "forbidden", title: "Forbidden" });
    }
  },
  validateSearch: strictSearch(parseActionsSearch),
  component: Actions,
});

function Actions() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <ActionsPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(narrowed) =>
        router.buildLocation({ to: "/settings/actions", search: narrowed }).href
      }
    />
  );
}
